import React from "react";
import { MessageCircle, X } from "lucide-react";
import { CONTACT, waLink } from "../lib/constants";

export default function WhatsappFab() {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - (rect.left + rect.width / 2);
    const y = e.clientY - (rect.top + rect.height / 2);
    el.style.transform = `translate(${x * 0.2}px, ${y * 0.2}px)`;
  };
  const onLeave = () => { if (ref.current) ref.current.style.transform = "translate(0,0)"; };

  return (
    <div className="fixed bottom-8 right-8 z-40">
      {open && (
        <div data-testid="whatsapp-popover" className="absolute bottom-20 right-0 w-72 glass soft-shadow rounded-md p-4 mb-2 origin-bottom-right animate-fade-up">
          <div className="flex items-center justify-between mb-3">
            <span className="caption text-[#B5896E]">Chat With Us</span>
            <button data-testid="whatsapp-popover-close" onClick={() => setOpen(false)} className="text-[#4A3F35]/60 hover:text-[#4A3F35]" aria-label="close">
              <X size={14} />
            </button>
          </div>
          <div className="space-y-1">
            {CONTACT.phones.map((p) => (
              <a
                key={p.label}
                data-testid={`whatsapp-option-${p.label.toLowerCase()}`}
                href={waLink(`Hello Blue Velvet, I'd like to reach ${p.label}.`, p)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between gap-3 px-3 py-3 rounded-sm hover:bg-[#F4E8DC] transition-colors group"
              >
                <div>
                  <div className="text-xs tracking-[0.18em] uppercase text-[#4A3F35]/55">{p.label}</div>
                  <div className="text-sm text-[#4A3F35]">{p.number}</div>
                </div>
                <MessageCircle size={16} className="text-[#B5896E] group-hover:scale-110 transition-transform" />
              </a>
            ))}
          </div>
        </div>
      )}
      <button
        data-testid="whatsapp-fab"
        onClick={() => setOpen((s) => !s)}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        aria-label="WhatsApp menu"
        className="group"
      >
        <span
          ref={ref}
          className="flex items-center gap-3 pl-5 pr-6 py-4 bg-white border border-[#B5896E]/35 soft-shadow rounded-full transition-[transform,background] duration-500 hover:bg-[#B5896E] hover:border-[#B5896E]"
        >
          <MessageCircle size={18} className="text-[#B5896E] group-hover:text-white transition-colors" />
          <span className="text-xs tracking-[0.2em] uppercase text-[#4A3F35] group-hover:text-white transition-colors">WhatsApp Us</span>
        </span>
      </button>
    </div>
  );
}
